import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'ieeecis-cookie-consent';

const readStoredConsent = () => {
    try {
        const rawValue = window.localStorage.getItem(STORAGE_KEY);
        if (!rawValue) return null;

        const parsedValue = JSON.parse(rawValue);
        if (!parsedValue || (parsedValue.level !== 'essential' && parsedValue.level !== 'all')) {
            return null;
        }

        return parsedValue.level;
    } catch {
        return null;
    }
};

const persistConsent = level => {
    try {
        window.localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
                level,
                updatedAt: new Date().toISOString(),
            })
        );
    } catch {
        // Ignore storage write failures so the banner never breaks the site shell.
    }
};

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!readStoredConsent()) {
            setIsVisible(true);
        }
    }, []);

    const handleChoice = level => {
        persistConsent(level);
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <aside
            className="cookie-banner"
            role="dialog"
            aria-live="polite"
            aria-labelledby="cookie-banner-title"
            aria-describedby="cookie-banner-text"
        >
            <div className="cookie-banner__panel">
                <p className="cookie-banner__eyebrow">IEEE CIS UJ · Privacy Controls</p>
                <h2 id="cookie-banner-title" className="cookie-banner__title">Cookie and Browser Storage Notice</h2>
                <p id="cookie-banner-text" className="cookie-banner__text">
                    This website uses essential browser storage to preserve navigation state and remember your privacy choices.
                    Optional measurement features should only be enabled with your consent. Read the full details in our{' '}
                    <Link to="/privacy-policy" className="cookie-banner__link">Privacy Policy</Link>.
                </p>
                <div className="cookie-banner__actions">
                    <button type="button" className="cookie-banner__button cookie-banner__button--ghost" onClick={() => handleChoice('essential')}>
                        Essential Only
                    </button>
                    <button type="button" className="cookie-banner__button cookie-banner__button--primary" onClick={() => handleChoice('all')}>
                        Accept All
                    </button>
                </div>
            </div>
        </aside>
    );
};

export default CookieConsent;